/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Information about the partner
 */
export interface SearchPartnerResponse {
  /**
   * Partner \"customer value\"
   */
  value?: string;
  /**
   * Partner details - Intentionally left vague
   */
  details?: Array<string>;
}
